import React from 'react';

export default function MainButton({
  className = '',
  disabled = false,
  onClick,
  children,
  variant = 'primary',
  type = "button",
  ...props
}) {

  const baseClasses =
    "inline-flex items-center justify-center rounded-lg font-medium text-sm px-4 py-2 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer";

  const variants = {
      primary: "bg-primary text-white hover:enabled:bg-primaryHover",
      secondary: "bg-secondary text-darkGray hover:bg-secondaryHover",
      danger: "bg-red text-white hover:enabled:opacity-90"
  };

  const variantClasses = variants[variant] ?? variants.primary;

  return (
    <button
        type={type}
        disabled={disabled}
        onClick={onClick}
        className={`${baseClasses} ${variantClasses} ${className}`}
        {...props}
    >
        {children}
    </button>
    );
}